import { useState } from "react";
import { MapPin } from "lucide-react";

const PULSE = {
  Indore: {
    note: "India's cleanest city is scaling fast — metro, Super Corridor and a deep talent pool keep absorption strong.",
    corridors: "Super Corridor · Vijay Nagar · MR-10",
    bars: [
      ["Commercial rental yield", 72, "~7.2% p.a."],
      ["Warehouse demand index", 84, "High"],
      ["5-yr price growth", 68, "+9–11% p.a."],
    ],
  },
  Goa: {
    note: "Finite land, national demand. Value concentrates in irreplaceable micro-locations and the Verna–Ponda belt.",
    corridors: "Verna · Panaji · Porvorim",
    bars: [
      ["Commercial rental yield", 64, "~6.4% p.a."],
      ["Warehouse demand index", 58, "Rising"],
      ["5-yr price growth", 81, "+12–14% p.a."],
    ],
  },
};

export default function MarketPulse() {
  const [city, setCity] = useState("Indore");
  const data = PULSE[city];
  return (
    <section className="pulse-section" data-testid="market-pulse">
      <div className="pulse-inner section-wrap">
        <div className="pulse-copy">
          <p className="eyebrow light-eyebrow">MARKET PULSE</p>
          <h2>Two cities.<br /><em>Live signals.</em></h2>
          <p>{data.note}</p>
          <p className="pulse-corridors" data-testid="pulse-corridors"><MapPin size={14} /> {data.corridors}</p>
        </div>
        <div className="pulse-panel">
          <div className="pulse-tabs" data-testid="pulse-city-tabs">
            {Object.keys(PULSE).map((c) => <button key={c} className={city === c ? "selected" : ""} onClick={() => setCity(c)} data-testid={`pulse-tab-${c.toLowerCase()}`}>{c}</button>)}
          </div>
          <div className="pulse-bars" key={city}>
            {data.bars.map(([label, value, display], index) => (
              <div className="pulse-bar-row" key={label} data-testid={`pulse-bar-${index}`}>
                <div className="pulse-bar-head"><span>{label}</span><strong>{display}</strong></div>
                <div className="pulse-track"><div className="pulse-fill" style={{ width: `${value}%`, transitionDelay: `${index * 120}ms` }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
